import { render } from "./EditLanguage.vue?vue&type=template&id=87b4acae"
import script from "./EditLanguage.vue?vue&type=script&lang=js"
export * from "./EditLanguage.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/orangehrm/orangehrm/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__